import { CASES } from './constants';

const initialState = {
    metrics: [],
    filterForm: {
        jobType: '',
    },
    isModalOpen: false,
    totalPages: 0,
    totalItems: 0,
    currentPage: 0,
    rangeParam: [0, 19],
    defaultFilterRange: [0, 19],
    sortParam: ['id', 'DESC'],
    itemsPerPage: 15,
};

export function jobMetrics(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CASES.UPDATE_JOB_METRICS: {
            return { ...state, ...payload };
        }
        case CASES.UPDATE_JOB_METRICS_FORM: {
            const { data, key } = payload;
            return { ...state, [key]: { ...state[key], ...data } };
        }
        case CASES.CLEAR_JOB_METRICS: {
            return initialState;
        }
        default:
            return state;
    }
}
